import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSocialMediaTasks,
  scrapeFacebook,
  scrapeInstagram,
  scrapeYoutube,
} from "./scrapeAPI";

export const facebookScraper = createAsyncThunk(
  "scrape/facebook",
  async (page, thunkAPI) => {
    try {
      const data = await scrapeFacebook(page);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const youtubeScraper = createAsyncThunk(
  "scrape/youtube",
  async (channel, thunkAPI) => {
    try {
      const data = await scrapeYoutube(channel);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const instagramScraper = createAsyncThunk(
  "scrape/instagram",
  async (profile, thunkAPI) => {
    try {
      const data = await scrapeInstagram(profile);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchSocialMediaTasks = createAsyncThunk(
  "scrape/socialMediaTasks",
  async (source, thunkAPI) => {
    try {
      return await getSocialMediaTasks(source);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

const scrapeSlice = createSlice({
  name: "scrape",
  initialState: {
    loading: false,
    tasksLoading: false,
    socialMediaTasks: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(facebookScraper.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(facebookScraper.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(facebookScraper.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(youtubeScraper.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(youtubeScraper.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(youtubeScraper.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(instagramScraper.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(instagramScraper.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(instagramScraper.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchSocialMediaTasks.pending, (state) => {
        state.tasksLoading = true;
        state.error = null;
      })
      .addCase(fetchSocialMediaTasks.fulfilled, (state, action) => {
        state.tasksLoading = false;
        state.socialMediaTasks = action.payload;
      })
      .addCase(fetchSocialMediaTasks.rejected, (state, action) => {
        state.tasksLoading = false;
        state.error = action.payload;
      })

      .addCase("task/deleteTask/fulfilled", (state, action) => {
        const taskId = action.payload?.taskId;
        if (taskId && Array.isArray(state.socialMediaTasks)) {
          state.socialMediaTasks = state.socialMediaTasks.filter(
            (t) => t.uuid !== taskId,
          );
        }
      })

      .addCase("task/deleteAction/fulfilled", (state, action) => {
        const updatedTask = action.payload;

        if (updatedTask?.uuid && Array.isArray(state.socialMediaTasks)) {
          const found = state.socialMediaTasks.find(
            (t) => t.uuid === updatedTask.uuid,
          );

          if (found) {
            if (Array.isArray(updatedTask.actions)) {
              found.actionsCount = updatedTask.actions.length;
            } else {
              found.actionsCount = Math.max(0, (found.actionsCount || 0) - 1);
            }
          }
        }
      });
  },
});

export default scrapeSlice.reducer;
